export default {
    code: {
        SUCCESS: 0,
        SYSTEM_FAILED: 1,
        FORBID: 2,
        NOT_FOUND: 3,
        ALREADY_EXISTED: 4,
        MEMBER_NOT_EXISTED: 5,
        TEXT_LENGTH_INCORRECT: 6,
        COUNT_EXCEED: 7,
        SIZE_EXCEED: 8,
        TYPE_FAILED: 9,
        CUSTOMER_SERVICE_CHAT_NOT_INIT: 10,
        CUSTOMER_SERVICE_OFFLINE: 11,
        CUSTOMER_SERVICE_WAITING: 12,
        CUSTOMER_SERVICE_SERVING: 13,
        CUSTOMER_SERVICE_SERVING_BY_OTHERS: 14,
        VIP_LEVEL_NOT_MATCH: 15,
        PASSWORD_INCORRECT: 16,
        DAILY_DEPOSIT_NOT_ENOUGH: 17,
        DAILY_BET_NOT_ENOUGH: 18,
        UNKNOWN: 9999,
    },
    messageType: {
        TEXT: 1,
        IMAGE: 2,
        EMOTION: 3,
        BET: 4,
        RED_PACK_ACTIVITY: 5,
        RED_PACK_ACTIVITY_RECEIVE: 6,
        BET_PLAN: 7,

        // 只在網頁使用
        ERROR: 1001,
        WARNING: 1002,
        INFO: 1003,
        CUSTOMER_SERVICE_QUESTION_LIST: 1004,
        CUSTOMER_SERVICE_WAITING_INFO: 1005,
        SITE_GROUP_SYSTEM_MESSAGE: 1006,
    },
    roomType: {
        SYSTEM: 1,
        CUSTOMER_SERVICE: 2,
        ANCESTOR: 3,
        DESCENDANT: 4,
        SERVING: 5,
        WAITING: 6,
        SEARCH: 7,
        DESCENDANT_GROUP: 8,
        FRIEND_GROUP: 9,
        ANCESTOR_FAMILY: 10,
        DESCENDANT_FAMILY: 11,
        SITE: 12,
        SITE_GROUP: 13,
        SITE_GROUP_TUTOR: 14,
    },
    serverRoomType: {
        SYSTEM: 1,
        CUSTOMER_SERVICE: 2,
        USER: 3,
        ANONYMITY: 4,
        GROUP: 5,
        FAMILY: 6,
        SITE: 7,
        SITE_GROUP: 8,
        SITE_GROUP_TUTOR: 9,
    },
    roomMemberRole: {
        NONE: 0,
        ADMIN: 1,
        MEMBER: 2,
        MANAGER: 3,
    },
    roomPrefix: {
        SYSTEM: "System",
        CUSTOMER_SERVICE: "CustomerService",
        FAMILY: "Family",
        ANONYMITY: "Anonymity",
    }
}
